"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ContentFrameData2 = _interopRequireDefault(require("./ContentFrameData"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BitmapFrameData = /*#__PURE__*/function (_ContentFrameData) {
  (0, _inherits2["default"])(BitmapFrameData, _ContentFrameData);

  var _super = _createSuper(BitmapFrameData);

  /** @type {HTMLCanvasElement|HTMLImageElement|ImageBitmap} */
  function BitmapFrameData(bitmap, naturalWidth, naturalHeight) {
    var _this;

    (0, _classCallCheck2["default"])(this, BitmapFrameData);
    _this = _super.call(this, naturalWidth, naturalHeight);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_bitmap", null);
    _this._bitmap = bitmap;
    return _this;
  }

  (0, _createClass2["default"])(BitmapFrameData, [{
    key: "equals",
    value: function equals(inBitmapFrameData) {
      if (!BitmapFrameData.isBitmapFrameData(inBitmapFrameData)) return false;
      if (this === inBitmapFrameData) return true;
      return (0, _get2["default"])((0, _getPrototypeOf2["default"])(BitmapFrameData.prototype), "equals", this).call(this, inBitmapFrameData) && inBitmapFrameData.bitmap === this.bitmap;
    }
  }, {
    key: "bitmap",
    get: function get() {
      return this._bitmap;
    },
    set: function set(value) {
      this._bitmap = value;
    }
  }, {
    key: "naturalHeight",
    get: function get() {
      return this._naturalHeight;
    },
    set: function set(value) {
      this._naturalHeight = value;
    }
  }, {
    key: "naturalWidth",
    get: function get() {
      return this._naturalWidth;
    },
    set: function set(value) {
      this._naturalWidth = value;
    }
  }], [{
    key: "isBitmapFrameData",
    value: function isBitmapFrameData(bitmapFrameData) {
      return bitmapFrameData instanceof BitmapFrameData;
    }
  }]);
  return BitmapFrameData;
}(_ContentFrameData2["default"]);

exports["default"] = BitmapFrameData;